( function ( _s ) {
	_s.fn.learnDashLogin = function () {
		return this.each( el => {
			const _self = _s( el );
			const _modalHeading = _self.find( '.ld-modal-heading' );
			const _image = _self.find( '.ld-login-modal-branding img' );
			const _register = _self.find( '.ld-login-modal-register' );
			const _remember = _self.find( '.login-remember' );
			const _resetPassword = _self.find( '.ld-forgot-password-link' );
			const _submitContainer = _self.find( '.login-submit' );
			const _signUpLinks = _s( '[href="#sign-up"]' );

			const resetPasswordLink = _resetPassword.attr( 'href' );
			const registerLink = _self.find( '.ld-login-modal-register a' ).attr( 'href' );

			_self
				.addClass( 'wysiwyg-content wysiwyg-with-title-decorations' )
				.find( '.ld-login-modal > *' )
				.wrapAll( '<div class="ld-login-modal-content-wrapper"></div>' );

			if ( _image.length && _register.length ) {
				_register.html( '' );
				_register.append( _image.firstElement() );
			}

			if ( _modalHeading.length ) {
				_modalHeading.html( '<h3>SIGN IN</h3>' );
			}

			if ( _resetPassword.length && _remember.length ) {
				_remember.append( `<a href="${ resetPasswordLink }">Forgot your password?</a>` );
			}

			if ( _submitContainer.length ) {
				_submitContainer.find( '[type="submit"]' ).addClass( 'cta-button primary' );
				_submitContainer.after(
					`<p>Don't have an account? <a href="${ registerLink }">Register</a></p>`
				);
			}

			_signUpLinks.each( link => {
				_s( link ).attr( 'href', registerLink );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.learndash-wrapper-login-modal' ).learnDashLogin();
	} );
} )( window._s );
